// This file was auto-generated by Fern from our API Definition.
export var BuiltinToolConfig;
(function (BuiltinToolConfig) {
    BuiltinToolConfig.Permission = {
        Allow: "allow",
        Ask: "ask",
        Deny: "deny",
    };
})(BuiltinToolConfig || (BuiltinToolConfig = {}));
